<form [formGroup]="misReportFilterForm" class="ledger-filter-form">
    <div class="flexbox aff-info">
      <div class="flexbox aff-info-inner w-100">  
        <div class="d-flex mt-5 justify-content-center ">
          <div class="input-fiel">
            <!-- <button id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" 
              searchtabindex="3" (click)="search()">
              Search</button> -->
             <!-- <button id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" 
              searchtabindex="3"[disabled]="misReportFilterForm.invalid"
              (click)="search(misReportFilterForm.value)">
              Get Branch Report </button>
              <button *ngIf=isOsakaAdmin  id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" 
              searchtabindex="3"[disabled]="misReportFilterForm.invalid"
              (click)="searchCOnsolidate()">
              Get Consolidate report</button>
            
			<button *ngIf=isOsakaAdmin  type="button" class="btn-style bg-purple ml-3" (click)="openInNewTab()">
            Open Branch Report in New Tab
          </button>
          <button type="button" class="btn-style bg-purple ml-3" (click)="openConsolidateInNewTab()">
            Open Consolidate Report in New Tab
          </button> -->
          <button id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" data-dismiss="modal"
              #searchButton (keyup.enter)="clickSearchButton()"
              (click)="search()">
              Search</button>
              </div>
        </div>      
  
      </div>
    </div>
  </form>

<div *ngIf="showIframe" class="mt-3" style="height:80vh;">
  <iframe
    [src]="safeSheetUrl"
    width="100%"
    height="100%"
    style="border:none;"
    loading="lazy"
    referrerpolicy="no-referrer">
  </iframe>
</div>
